<template>
    <div>
        <slot>
            <div class="page-breadcrumb">
                <div class="row">
                    <div class="col-md-8 align-self-center">
                        <h4 class="page-title">Setting Payment Received</h4>
                    </div>
                    <div class="col-md-4 align-self-center">
                        <div class="d-flex align-items-right justify-content-end">
                            <router-link :to="{ name: 'Setting' }" class="btn btn-info btn-sm mr-2 ctrlbtn" style="margin-bottom: 10px;width: -webkit-fill-available;">
                                <i class="fas fa-arrow-left"></i>
                                Back
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <form @submit.prevent="MetSavesettingPayments">
                            <div class="card">
                                <div class="card-header">Email Message</div>
                                <div class="card-body">
                                    <div class="bgloading" v-if="FormSetting.isLoading">
                                        <Loader></Loader>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 ctrlbtnShow">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                </div>
                                                <div class="col-md-6">
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 ctrlbtnHiden">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div> 
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label for="staticEmail" class="col-sm-2 col-form-label">
                                                        Greeting
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div style="margin-left:30px;">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="customControlAutosizing"
                                                            v-model="FormSetting.greeting"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="customControlAutosizing"
                                                            >Insert a greeting before the message
                                                            text</label
                                                        > 
                                                    </div>                                            
                                                </div>  
                                            </div>                                            
                                        </div>
                                    </div> 

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div style="margin-right: 10px">
                                                <label
                                                    class="form-check-label"
                                                    for="inlineFormCheck"
                                                    ><b>Greeting format:</b></label
                                                >
                                            </div>
                                        </div>    
                                        <div class="col-md-4">
                                            <select class="form-control" style="margin-right: 10px;margin-bottom:10px;"
                                                v-model="FormSetting.greetingFormat1"
                                                :disabled="FormSetting.greeting ? disabled : ''"
                                            >
                                                <option value="1">Dear:</option>
                                                <option value="2">To:</option>
                                            </select>                                            
                                        </div>    
                                        <div class="col-md-4">
                                            <select class="form-control"
                                                v-model="FormSetting.greetingFormat2"
                                                :disabled="FormSetting.greeting ? disabled : ''"
                                            >
                                                <option value="1">Full Name</option>
                                                <option value="2">
                                                    Business Name
                                                </option>
                                            </select>                                            
                                        </div>                                                                                                                            
                                    </div> 
                                    <hr />
                                    <div class="form-group row">
                                        <label for="" class="col-sm-2 col-form-label"
                                            >Message</label
                                        >
                                        <div class="col-sm-10">
                                            <div class="">
                                                <span class="control-label"
                                                    ><b>PAYMENTS</b>
                                                    <button
                                                        type="button"
                                                        class="btn btn-secondary btn-sm"
                                                        @click="MetDefaultMessage"
                                                        style="
                                                            margin-left: 10px;
                                                            border-radius: 5px;
                                                        "
                                                    >
                                                        Use Standard Message
                                                    </button>
                                                </span>
                                            </div>
                                            <div style="margin-top: 15px">
                                                <div class="form-group row">
                                                    <label
                                                        for=""
                                                        class="col-sm-2 col-form-label text-right"
                                                        >Subject:</label
                                                    >
                                                    <div class="col-sm-10">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                FormSetting.messagesubjet
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        for=""
                                                        class="col-sm-2 col-form-label text-right"
                                                        >Message:</label
                                                    >
                                                    <div class="col-sm-10">
                                                        <textarea
                                                            class="form-control"
                                                            id=""
                                                            rows="10"
                                                            v-model="
                                                                FormSetting.messagetext
                                                            "
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">Options</div>
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label
                                            for="inputPassword"
                                            class="col-sm-1 col-form-label"
                                        ></label>
                                        <div class="col-sm-11">
                                            <div style="margin-top: 15px">
                                                <div class="form-group row">
                                                    <label
                                                        for="jobi"
                                                        class="col-sm-3 col-form-label text-right"
                                                        >Picture Quality:</label
                                                    >
                                                    <div class="col-sm-9">
                                                        <select
                                                            class="form-control"
                                                            id=""
                                                            v-model="
                                                                FormSetting.picture_quality
                                                            "
                                                        >
                                                            <option value="20">
                                                                20%
                                                            </option>
                                                            <option value="30">
                                                                30%
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 ctrlbtnShow">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                </div>
                                                <div class="col-md-6">
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 ctrlbtnHiden">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </slot>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader";
export default {
    components: {
        Loader,
    },
    data() {
        return {
            disabled: false,
            FormSetting: {
                isLoading: false,
                user_id: null,
                action: "Add",
                greeting: false,
                greetingFormat1: 1,
                greetingFormat2: 1,
                messagesubjet: null,
                messagetext: null,
                picture_quality: 0,
            },
            DefaultMessage: {
                Subject: null,
                Message: null,
            },
        };
    },
    created() {
        this.getCompanyInfo();
    },
    methods: {
        getCompanyInfo() {
            this.isLoading = true;
            window.billing
                .get("companyinfo/" + window.localuserdata)
                .then((response) => {
                    console.log(response.data);
                    this.DefaultMessage.Subject = "Payments from %COMPANY_NAME%";
                    this.DefaultMessage.Message =
                        "Your invoice is attached. \n\nThank you for your business - we appreciate it very much.\n\n\nSincerely,\n%COMPANY_NAME%";
                    this.getPaymentSetting();
                })
                .catch((error) => console.log(error));
        },
        MetDefaultMessage() {
            this.FormSetting.messagesubjet = this.DefaultMessage.Subject;
            this.FormSetting.messagetext = this.DefaultMessage.Message;
        },
        MetSavesettingPayments() {
            this.FormSetting.isLoading = true;
            if (this.FormSetting.action == "Add") {
                window.billing
                    .post("payments/setting", {
                        user_id: window.localuserdata,
                        greeting: this.FormSetting.greeting,
                        greetingFormat1: this.FormSetting.greetingFormat1,
                        greetingFormat2: this.FormSetting.greetingFormat2,
                        messagesubjet: this.FormSetting.messagesubjet,
                        messagetext: this.FormSetting.messagetext,
                        picture_quality: this.FormSetting.picture_quality,
                    })
                    .then((response) => {
                        this.FormSetting.action = "Update";
                        this.FormSetting.isLoading = false;

                        this.$notify({
                            group: "noti",
                            title: "Created",
                            type: "success",
                            text: "Created Template Successful",
                        });
                    })
                    .catch((error) =>
                        console.log(error, (this.FormSetting.isLoading = false))
                    );
            }
            if (this.FormSetting.action == "Update") {
                this.FormSetting.isLoading = true;
                window.billing
                    .put("payments/setting/" + window.localuserdata, {
                        user_id: window.localuserdata,
                        greeting: this.FormSetting.greeting,
                        greetingFormat1: this.FormSetting.greetingFormat1,
                        greetingFormat2: this.FormSetting.greetingFormat2,
                        messagesubjet: this.FormSetting.messagesubjet,
                        messagetext: this.FormSetting.messagetext,
                        picture_quality: this.FormSetting.picture_quality,
                    })
                    .then((response) => {
                        this.FormSetting.action = "Update";
                        this.FormSetting.isLoading = false;
                        this.$notify({
                            group: "noti",
                            title: "Updated",
                            type: "success",
                            text: "Updated Setting Successful",
                        });
                    })
                    .catch((error) =>
                        console.log(error, (this.FormSetting.isLoading = false))
                    );
            }
        },
        getPaymentSetting() {
            //this.FormestimateSetting.isLoading = true
            window.billing
                .get("payments/setting/" + window.localuserdata)
                .then((response) => {
                    console.log(response.data.result);
                    if (response.data.result.length) {
                        this.FormSetting.user_id = response.data.result[0].user_id;
                        this.FormSetting.greeting = response.data.result[0].greeting;
                        this.FormSetting.greetingFormat1 =
                            response.data.result[0].greetingFormat1;
                        this.FormSetting.greetingFormat2 =
                            response.data.result[0].greetingFormat2;
                        this.FormSetting.messagesubjet =
                            response.data.result[0].messagesubjet;
                        this.FormSetting.messagetext =
                            response.data.result[0].messagetext;
                        this.FormSetting.picture_quality =
                            response.data.result[0].picture_quality;
                        if (this.FormSetting.user_id !== null) {
                            this.FormSetting.action = "Update";
                        }
                    } else {
                        this.MetDefaultMessage();
                    }
                    this.FormSetting.isLoading = false;

                    console.log(response.data);
                })
                .catch((error) => console.log(error));
        },
    },
};
</script>
<style lang="scss" scoped>
#editor {
    height: 300px;
}
@media (min-width: 1279px) {
    .ctrlbtn {
        width:160px !important;
    }
    .ctrlbtnCustom {
        width:100px !important;
    }    
    .ctrlbtnShow {
        display: none !important;
    }    
}
@media (max-width: 1281px) {
    .ctrlbtnHiden {
        display: none !important;
    }    
}

.contenedor-table table thead tr th {
    font-weight: bold;
}
@media (max-width: 1100px) {
    .contenedor-table {
        max-width: 924px;
        overflow-x: scroll;
    }
}
</style>
